export enum FileUploaderErrorsEnum {
    None,
    InvalidFormat,
    InvalidFile,
    MultipleFilesNotAllowed
}